// B1 ① 입력 방식 — 3택 카드(사진·링크·직접 입력) + 팁. 이 단계에는 하단 CTA 가 없다.
// 카드를 누르면 곧바로 다음 화면으로 넘어간다(앱 simple_request_flow_screen.dart step 0).
// 데스크톱(props.desktop)은 같은 카드 3개를 가로 3열 세그먼트로만 바꾼다 — 선택 강조 = props.active.
import React from 'react';
import { T, R, FONT } from '../../../theme';
import { question, NoteBox } from './bits';

var opts = { display: 'flex', flexDirection: 'column', gap: 10 };
var optsRow = { display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0,1fr))', gap: 10 };
var opt = { display: 'flex', gap: 12, alignItems: 'flex-start', padding: '14px 14px', textAlign: 'start',
  border: '1px solid ' + T.bd, borderRadius: R.card, background: T.card, cursor: 'pointer', fontFamily: 'inherit', width: '100%' };
var optOn = { border: '1px solid ' + T.accent, background: T.accentTint };
var tile = { width: 34, height: 34, borderRadius: R.md, flex: 'none', display: 'grid', placeItems: 'center',
  background: T.accentTint, color: T.accentPress };
var tileOn = { background: T.accent, color: T.card };
var tx = { display: 'flex', flexDirection: 'column', gap: 3, minWidth: 0 };
var ot = { fontSize: 13.5, fontWeight: 800, color: T.ink, letterSpacing: '-.2px' };
var otOn = { color: T.accentPress };
var os = { fontSize: 11.5, color: T.muted, lineHeight: 1.6 };
var osClamp = { display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden' };
var tipTitle = { fontSize: 12, fontWeight: 800, color: T.accentPress, marginBottom: 2 };

function Glyph(props) {
  var st = { fill: 'none', stroke: 'currentColor', strokeWidth: 1.7, strokeLinecap: 'round', strokeLinejoin: 'round' };
  var body = props.id === 'photo'
    ? <g {...st}><rect x="3.4" y="5.4" width="17.2" height="13.2" rx="2.2" /><circle cx="9" cy="10.4" r="1.9" /><path d="M4.6 17.4l4.6-4.3 3.4 3 2.7-2.4 4.1 3.7" /></g>
    : props.id === 'link'
      ? <path d="M10.4 13.6a3.6 3.6 0 005.3.3l2.6-2.6a3.6 3.6 0 00-5.1-5.1l-1.4 1.4M13.6 10.4a3.6 3.6 0 00-5.3-.3l-2.6 2.6a3.6 3.6 0 005.1 5.1l1.4-1.4" {...st} />
      : <path d="M4.5 19.5l1-3.7L15.6 5.7a2 2 0 012.8 0l1.1 1.1a2 2 0 010 2.8L9.2 18.5l-4.7 1z" {...st} />;
  return <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" focusable="false">{body}</svg>;
}

function Option(props) {
  return (<button type="button" style={props.on ? Object.assign({}, opt, optOn) : opt}
    data-method={props.id} aria-pressed={props.pressable ? !!props.on : undefined} onClick={props.onClick}>
    <span style={props.on ? Object.assign({}, tile, tileOn) : tile}><Glyph id={props.id} /></span>
    <span style={tx}>
      <b style={props.on ? Object.assign({}, ot, otOn) : ot}>{props.title}</b>
      <small style={props.clamp ? Object.assign({}, os, osClamp) : os}>{props.sub}</small>
    </span>
  </button>);
}

function StepMethod(props) {
  var t = props.t;
  var d = !!props.desktop;
  return (<React.Fragment>
    {d ? null : <div style={question}>{t('simpleQ1')}</div>}
    <div style={d ? optsRow : opts}>
      <Option id="photo" title={t('simpleOcrTitle')} sub={t('simpleOcrSub')} onClick={props.onPhoto}
        on={props.active === 'photo'} pressable={d} clamp={d} />
      <Option id="link" title={t('simpleB3LinkTitle')} sub={t('simpleB3LinkSub')} onClick={props.onLink}
        on={props.active === 'link'} pressable={d} clamp={d} />
      <Option id="manual" title={t('simpleManualTitle')} sub={t('simpleManualSub')} onClick={props.onManual}
        on={props.active === 'manual'} pressable={d} clamp={d} />
    </div>
    {d ? null : (<NoteBox tone="accent">
      <div>
        <div style={tipTitle}>{t('simpleTipTitle')}</div>
        <div style={{ fontSize: FONT.label + .5 }}>{t('simpleTipSub')}</div>
      </div>
    </NoteBox>)}
  </React.Fragment>);
}

export default StepMethod;
